module.exports = __webpack_public_path__ + "img/ad-3.0d2f0268.png";